<template>
	<stats-card-v2
		colClasses="xs12"
		:heading="widget.text.caption[$i18n.locale]"
		:amount="value" :is-cash="isMoneyValue">
	</stats-card-v2>
</template>

<script>
	import { mapGetters } from 'vuex'
	import Enumerable from 'linq'

	export default {
		props: {
			widget: {
				type: Object,
				required: true
			}
		},
		data() {
			return {
				
			}
		},
		computed: {
			...mapGetters([
				'reportingData',
				'eventBaseGroups',
				'season'
			]),
			value: function () {
				if (this.reportingData.length > 0 && this.widget.data.sumField) {
					let enumerable = Enumerable.from(this.reportingData)
					
					if (this.widget.data.articleType.length > 0) {
						enumerable = enumerable.where(item => this.widget.data.articleType.includes(item['FK_ArticleType']))
					}
					if (this.widget.data.isOnlyContractual) {
						enumerable = enumerable.where(item => item['is_contractual'] == true)
					}

					if (this.widget.data.isOnlyNotContractual) {
						enumerable = enumerable.where(item => item['is_contractual'] == false)
					}

					if (this.widget.data.eventType && this.widget.data.eventType.trim() !== '') {
						enumerable = enumerable.where(item => item['event_type'] === this.widget.data.eventType.trim())
					}

					if (this.widget.data.partnerName && this.widget.data.partnerName.trim() !== '') {
						enumerable = enumerable.where(item => item['wo_partner_name'] === this.widget.data.partnerName.trim())
					}

					if (this.widget.data.shopRefId && this.widget.data.shopRefId.trim() !== '') {
						enumerable = enumerable.where(item => item['ShopFilterName'] === this.widget.data.shopRefId.trim())
					}

					if (this.widget.data.eventBaseGroups && this.widget.data.eventBaseGroups.length > 0) {
						const eventGroups = []
						this.eventBaseGroups
							.filter(item => this.widget.data.eventBaseGroups.includes(item.id))
							.map(item => item.groups.filter(g => g.FK_Season === this.season))
							.filter(group => group.length !== 0)
							.map(item => item.map(i => eventGroups.push(i)))

						const eventGroupIds = eventGroups.map(i => i.id)
						enumerable = enumerable.where(item => eventGroupIds.includes(item['event_group_id']))
					}

					// if (this.widget.data.isWithContractual) {
					// 	enumerable = enumerable.where(item => item['is_contractual'] == true || item['is_contractual'] == false)
					// }
					return enumerable
					.select(item => {
						const field = this.widget.data.sumField.field
						if (field === 'commissionCombined') {
							const com = Number(item['commission'] || 0)
							const comContractual = Number(item['contractualCommission'] || 0)
							return com + comContractual
						}
						if (field === 'commission' || field === 'contractualCommission') {
							const com = Number(item['commission'] || 0)
							const comContractual = Number(item['contractualCommission'] || 0)
							return Number(item[field] || 0)
						}
						return Number(item[field] || 0)
					})
					.sum()
				} else {
					return 0
				}
			},
			isMoneyValue: function () {
				return this.widget.data.sumField ? this.widget.data.sumField.isMoneyValue : false
			}
		},

		methods: {
			
		}
	};
</script>

